import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const toolsWordList = [
  "blade",
  "brush",
  "bulb",
  "camera",
  "canvas",
  "chain",
  "clock",
  "coil",
  "compass",
  "computer",
  "drum",
  "hammer",
  "knife",
  "lamp",
  "lens",
  "level",
  "map",
  "mouse",
  "nail",
  "needle",
  "pen",
  "pencil",
  "piano",
  "pump",
  "radio",
  "scale",
  "screen",
  "screw",
  "spring",
  "tape",
  "telephone",
  "valve",
  "watch",
  "wheel",
  "wire",
];

export const toolsCollection: WordCollection = createCollection(
  "tools",
  "Tools & Instruments",
  toolsWordList,
  { icon: "tools", isWordlistViewable: true },
);
